<template>
  <section class="w-full flex flex-col flex-1 overflow-y-auto pb-20 pt-5 sm:pt-0 transition-all">
    <Titre textePrincipal="Bienvenue sur notre " texteAccentue="site&nbsp;!" :isSidebarOpen="isSidebarOpen" />
    <div class="flex-1 max-w-7xl items-center mx-auto">
      <div class="flex flex-wrap items-center">
        <div class="w-full xl:w-1/2 px-2">
          <div class="w-full pb-6 pl-4 pr-9 space-y-6 md:space-y-4 lg:space-y-8 xl:space-y-4 font-serif">
            <p class="mx-auto text-md md:text-lg lg:text-xl text-justify text-gray-500 md:max-w-full">Nous sommes une
              équipe de bénévoles passionnés dédiée au bien-être des animaux. Situé à <span class="font-bold text-primaire font-cursive text-lg md:text-xl lg:text-2xl">Matane</span>, nous nous engageons à sauver des chats
              abandonnés et à les placer dans des familles aimantes.</p>
            <p class="mx-auto text-md md:text-lg lg:text-xl text-justify text-gray-500 md:max-w-full">Explorez nos
              sections : <b>«&nbsp;Nos
                chatons&nbsp;»</b>, <b>«&nbsp;Nos Femelles&nbsp;»</b> et <b>«&nbsp;Nos Mâles&nbsp;»</b> pour découvrir
              les
              adorables
              compagnons disponibles à l'adoption. Participez également à nos levées de fonds pour soutenir notre
              mission et avoir une chance de gagner des prix !</p>
            <p class="mx-auto text-md md:text-lg lg:text-xl text-justify text-gray-500 md:max-w-full">Nous acceptons
              les
              dons en argent ou en
              matériel (nourriture, litière, jouets, etc.). Pour toute question ou pour faire un don, n'hésitez pas à
              nous contacter via la section «&nbsp;Nous joindre&nbsp;».</p>
            <p class="mx-auto text-lg md:text-xl lg:text-2xl text-justify  text-gray-500 md:max-w-full font-cursive font-bold">Adoptez un
              chat, et changez une vie !</p>

            <div class="flex flex-col sm:flex-row sm:space-x-4 pt-4">
              <router-link to="/chatons-0-5-mois"
                class="flex items-center w-full px-6 py-3 mb-3 text-lg text-white bg-navigation rounded-md sm:mb-0 hover:bg-primaire sm:w-auto"
                aria-label="Voir les chatons de 0 à 5 mois" title="Voir les chatons de 0 à 5 mois"
                data-primary="indigo-600" data-rounded="rounded-md">
                Chats disponibles pour adoption

                <svg class="w-5 h-5 ml-1" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                  stroke-linecap="round" stroke-linejoin="round">
                  <line x1="5" y1="12" x2="19" y2="12"></line>
                  <polyline points="12 5 19 12 12 19"></polyline>
                </svg>
              </router-link>
            </div>
          </div>
        </div>
        <div class="w-full xl:w-1/2 px-5 md:px-0 lg:px-5 mx-auto">
          <div class="w-full h-auto overflow-hidden rounded-md shadow-xl sm:rounded-xl" data-rounded="rounded-xl"
            data-rounded-max="rounded-full">
            <img src="/img/animaux_de_la_seconde_chance_adoption.jpg"
              alt="Chat"
              title="Animaux de la seconde chance"
              width="600"
              height="400"
              class="w-full h-auto object-cover object-center" />
          </div>
        </div>

      </div>
    </div>

    <NouveauxArrivants />
    <NouveauxAdoptes />
    <Remerciements />

  </section>
</template>

<script>
import { ref } from 'vue';
import Titre from '../composants/Titre.vue';
import NouveauxArrivants from '../composants/NouveauxArrivants.vue';
import NouveauxAdoptes from '../composants/NouveauxAdoptes.vue';
import Remerciements from '../composants/Remerciements.vue';

export default {
  name: 'Accueil',
  components: {
    NouveauxArrivants,
    NouveauxAdoptes,
    Remerciements,
    Titre
  },
  setup() {
    const isSidebarOpen = ref(false);
    return { isSidebarOpen };
  },
};
</script>

<style scoped>

.ml-64 {
  margin-left: 16rem;
}

img {
  aspect-ratio: 4 / 3;
  width: 100%;
  height: auto;
}


</style>